import React from 'react';
import { Card } from 'react-bootstrap';
import AdminSmsGatewayDashboard from './pages/AdminSmsGatewayDashboard';
const AdminSmsGateway = () => {
    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-chat-dots"></i> SMS Gateway Stats
                </h1>
            </div>

            <Card className="admin-sms-gateway-card shadow-sm border-0">
                <Card.Body className="p-3">
                    <AdminSmsGatewayDashboard />
                </Card.Body>
            </Card>
        </div>
    );
};

export default AdminSmsGateway;
